// Contenido central de España Eficiente (E²)
// NOTA: los PDFs de Policy Briefs son placeholders (apuntan al doc real de la Carta)
// hasta conectar los PDFs definitivos.

export const SITE = {
  name: "España Eficiente",
  mark: "E²",
  slogan: "Eficiencia, transparencia y prosperidad para España",
  tagline:
    "Iniciativa independiente de reforma política, administrativa y tecnológica. Propuestas útiles y realizables para una Administración más eficiente y unas instituciones más transparentes.",
  origin: "Nacida en Galicia · Vocación nacional",
  cartaPdf:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/00rzjrw8_Carta_Responsabilidad_EspanaEficiente_E2-1.pdf",
  social: {
    tiktok: "https://www.tiktok.com/@espanaeficiente",
    x: "https://x.com/espanaeficiente",
    linkedin: "https://www.linkedin.com/in/espa%C3%B1a-eficiente-e%C2%B2-70a5b7400",
    facebook: "https://www.facebook.com/share/1AEBV7jsWr/",
  },
  email: "contacto@espanaeficiente.es",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/14897462/pexels-photo-14897462.jpeg",
  methodology: "https://images.pexels.com/photos/577210/pexels-photo-577210.jpeg",
  documents: "https://images.pexels.com/photos/7731326/pexels-photo-7731326.jpeg",
  institutional: "https://images.pexels.com/photos/36883772/pexels-photo-36883772.jpeg",
  auxilia:
    "https://images.unsplash.com/photo-1649923207998-43ac79d00667?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV = [
  { id: "carta", label: "Carta de Responsabilidad" },
  { id: "firma", label: "Firma" },
  { id: "areas", label: "Áreas" },
  { id: "quienes", label: "Quiénes somos" },
  { id: "briefs", label: "Policy Briefs" },
  { to: "/mapa", label: "Mapa" },
  { to: "/auxilia", label: "AUXILIA" },
  { id: "noticias", label: "Actividad" },
  { id: "contacto", label: "Contacto" },
];

export const DESTACADAS = [
  {
    icon: "Coins",
    title: "Ahorro y Eficiencia",
    text: "Medidas para optimizar el gasto público, eliminar duplicidades y mejorar la gestión de los recursos.",
  },
  {
    icon: "Landmark",
    title: "Transparencia Política",
    text: "Propuestas para reforzar la rendición de cuentas, la transparencia institucional y la responsabilidad pública.",
  },
  {
    icon: "Cpu",
    title: "Innovación Tecnológica",
    text: "Tecnología, digitalización e inteligencia artificial al servicio de los ciudadanos y la Administración.",
  },
];

export const AREAS = [
  { icon: "ClipboardList", title: "Programa E²", text: "Propuestas de reforma política, económica y administrativa." },
  { icon: "Coins", title: "Ahorro y Eficiencia", text: "Optimizar el gasto y eliminar duplicidades." },
  { icon: "Landmark", title: "Transparencia Política", text: "Rendición de cuentas y responsabilidad pública." },
  { icon: "Cpu", title: "Innovación Tecnológica", text: "Digitalización e IA al servicio del ciudadano." },
  { icon: "LifeBuoy", title: "Sistemas E²", text: "Proyectos propios como AUXILIA E²." },
  { icon: "FileText", title: "Policy Briefs · Análisis", text: "Documentos técnicos sobre los retos de España." },
];

export const PRINCIPIOS = [
  "Eficiencia en la gestión pública",
  "Transparencia y rendición de cuentas",
  "Igualdad ante la ley",
  "Responsabilidad institucional",
  "Innovación tecnológica al servicio de las personas",
  "Simplificación administrativa",
  "Sostenibilidad económica y social",
  "Participación ciudadana y mejora continua",
];

export const METODOLOGIA = [
  {
    step: "01",
    title: "Definición del problema",
    text: "Se delimita un reto público concreto (economía, sanidad, vivienda, empleo, emergencias o gobernanza) con indicadores medibles.",
  },
  {
    step: "02",
    title: "Fuentes y datos",
    text: "Trabajamos con fuentes oficiales y públicas: INE, Eurostat, IGAE, Banco de España, AIReF, boletines oficiales (BOE/DOG) y organismos europeos.",
  },
  {
    step: "03",
    title: "Análisis y contraste",
    text: "Cada propuesta se contrasta con el marco legal (Constitución, normativa vigente) y con experiencias comparadas de otros países.",
  },
  {
    step: "04",
    title: "Publicación abierta",
    text: "El resultado es un Policy Brief con referencias citadas, descargable en PDF y abierto al escrutinio público.",
  },
];

export const STATS = [
  { value: "62", label: "Policy Briefs publicados" },
  { value: "8", label: "Principios de gobernanza" },
  { value: "100%", label: "Fuentes públicas y citadas" },
  { value: "0", label: "Excusas ante el incumplimiento" },
];

export const BRIEFS = [
  {
    id: "pb-jornada-40h",
    title:
      "Jornada Laboral: 40 horas bien distribuidas, viernes tarde libre y llegar antes a casa",
    topic: "Reforma Laboral",
    date: "2026-07-01",
    summary:
      "Redistribución inteligente de las 40 horas semanales sin reducir producción ni aumentar costes para la empresa. Permite salir antes de lunes a jueves y tener la tarde del viernes libre, mejorando la conciliación sin cambiar la ley ni el salario.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/ag25fs2t_JornadaLaboral_PolicyBrief-2.pdf",
  },
  {
    id: "pb-jornada-continua",
    title: "Jornada Continua Adaptada: flexibilidad para trabajos físicos y al aire libre",
    topic: "Reforma Laboral",
    date: "2026-07-01",
    summary:
      "Segunda opción de E² diseñada para trabajos físicos y al aire libre. Optimiza la jornada mediante la flexibilidad en el cómputo del descanso y la adaptación a cada convenio colectivo, buscando equilibrio entre productividad, seguridad y conciliación.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/73rwbhp4_JornadaContinua_PolicyBrief-1.pdf",
  },
  {
    id: "pb-jornada-comparativa",
    title:
      "Comparativa: reducción de jornada — Gobierno actual vs Europa vs España Eficiente",
    topic: "Reforma Laboral",
    date: "2026-05-06",
    summary:
      "Modelo de reducción de jornada basado en el consenso entre empresas y trabajadores y la flexibilidad sectorial, al estilo de los países europeos con mejores condiciones. Defiende la negociación colectiva frente a los decretos unilaterales.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/rp0yu7kl_JornadaLaboral_Comparativa-1.pdf",
  },
  {
    id: "pb-fraude-it",
    title:
      "Protección de empresas y autónomos frente al fraude en la incapacidad temporal",
    topic: "Empleo y Economía",
    date: "2026-06-15",
    summary:
      "Sistema equilibrado que protege al trabajador enfermo y a la vez salvaguarda la viabilidad de empresas y autónomos frente al uso abusivo de la incapacidad temporal, con mecanismos de comprobación objetivos y respuestas proporcionales.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/1tokuvx6_Protecci%C3%B3n%20fraude%20laboral.pdf",
  },
  {
    id: "pb-sindicatos-patronal",
    title:
      "Financiación y transparencia de sindicatos y patronal: quien recibe dinero público rinde cuentas",
    topic: "Transparencia Política",
    date: "2026-06-01",
    summary:
      "Sindicatos y organizaciones empresariales que reciben fondos públicos deben cumplir las mismas obligaciones de transparencia y rendición de cuentas que cualquier entidad que gestione dinero del contribuyente. Un mismo rasero para todas las organizaciones.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/lm2ui2ul_SindicatosPatronal_PolicyBrief.pdf",
  },
  {
    id: "pb-natalidad",
    title: "Plan Nacional de Natalidad, Familia y Conciliación",
    topic: "Familia y Sociedad",
    date: "2026-07-20",
    summary:
      "Modelo integral para eliminar los obstáculos económicos, laborales y sociales que impiden formar una familia. Incluye protección a la maternidad y paternidad, conciliación real y apoyo económico, desde la libertad de elección y la equidad.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/3opqqi4y_Policy_Brief_Natalidad_Familia_Conciliacion_E2-1.pdf",
  },
  {
    id: "pb-proteccion-civil",
    title: "Plan Nacional de Protección Civil y Gestión de Emergencias (SNIGE-E²)",
    topic: "Emergencias y Seguridad",
    date: "2026-07-15",
    summary:
      "Creación de un Sistema Nacional Inteligente que integra tecnología, información y recursos humanos para una gestión de emergencias más proactiva, coordinada y eficiente, con foco en la prevención y la anticipación de riesgos.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/hy3t40ta_Policy_Brief_Proteccion_Civil_E2_v2.pdf",
  },
  {
    id: "pb-modernizacion-militar",
    title: "Plan Nacional de Modernización del Equipamiento Militar",
    topic: "Emergencias y Seguridad",
    date: "2026-07-10",
    summary:
      "La inversión en defensa como motor de seguridad nacional, soberanía tecnológica, industria y empleo cualificado. Hoja de ruta hacia el objetivo del 2% del PIB con retorno industrial estratégico.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/n7bpwdq3_PolicyBrief_ModernizacionMilitar_E2.pdf",
  },
  {
    id: "pb-turismo",
    title: "Plan Nacional de Turismo de Calidad y Sostenible",
    topic: "Economía y Turismo",
    date: "2026-07-05",
    summary:
      "Transición del turismo de masas a un modelo de calidad, sostenible e integrado con la cultura, la gastronomía y la economía local. Busca aumentar el valor por visitante, aliviar destinos saturados y potenciar el interior.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/zpc86zc3_PolicyBrief_TurismoCalidad_E2.pdf",
  },
  {
    id: "pb-trabajador-enfermo",
    title: "Protección del trabajador enfermo o incapacitado: más rápida, justa y digna",
    topic: "Empleo y Economía",
    date: "2026-06-20",
    summary:
      "Sistema basado en evidencia médica objetiva que agiliza el reconocimiento de la incapacidad, reasigna a tareas compatibles y elimina juicios innecesarios, protegiendo al trabajador sin perjudicar su vida.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/cavhdk84_TrabajadorEnfermo_PolicyBrief.pdf",
  },
  {
    id: "pb-trabajador-enfermo-legal",
    title: "Protección del trabajador enfermo o incapacitado temporal (marco legal)",
    topic: "Empleo y Economía",
    date: "2026-06-22",
    summary:
      "Sistema integral que protege a los trabajadores temporalmente enfermos o con lesiones crónicas, garantizando sus derechos económicos y laborales. Agiliza el reconocimiento de incapacidades, asigna tareas compatibles y evita litigios, beneficiando a trabajador, empresa y Estado.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/fw1zifs6_Proteccion%20al%20trabajador%20legal.pdf",
  },
  {
    id: "pb-trabajador-enfermo-anexo",
    title: "Anexo técnico: valoración por profesión y verificación objetiva (Sistema GIF)",
    topic: "Empleo y Economía",
    date: "2026-06-25",
    summary:
      "Valoración de la incapacidad que va más allá del diagnóstico y atiende a las limitaciones funcionales en la profesión habitual. Incorpora un sistema automatizado de verificación objetiva (GIF) para agilizar procesos, reducir burocracia y combatir el fraude.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/jirxnbsf_Anexo-trabajador-enfermo.pdf",
  },
  {
    id: "pb-practicas-abusivas",
    title: "Plan Nacional contra las Prácticas Abusivas",
    topic: "Transparencia Política",
    date: "2026-08-01",
    summary:
      "Refuerza la detección, sanción y reparación de prácticas abusivas para proteger a ciudadanos, trabajadores y empresas honestas. No más regulación, sino mejor aplicación de la existente, con sanciones disuasorias y reparación ágil para los afectados.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/70yn8vc7_PolicyBrief_PracticasAbusivas_E2.pdf",
  },
  {
    id: "pb-fondo-nacional",
    title: "Fondo Nacional (0,5% universal): impacto a 10 años",
    topic: "Empleo y Economía",
    date: "2026-07-28",
    summary:
      "Creación de un Fondo Nacional que recauda el 0,5% de forma universal para cubrir indemnizaciones por despido. El análisis a 10 años concluye que, con gestión prudente y automática, el sistema es viable, equilibrado y protegible ante crisis.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/qa36c4vc_Hucha%20nacional%2C10%20a%C3%B1os.pdf",
  },
  {
    id: "pb-pacto-social",
    title: "El Nuevo Pacto Social: reforma de cotizaciones y fiscalidad",
    topic: "Economía y Turismo",
    date: "2026-07-25",
    summary:
      "Reforma del sistema de cotización y fiscalidad para lograr equidad y sostenibilidad: tramos de contribución progresivos, bases vinculadas al coste real de la empresa e incentivos a la inversión productiva en España.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/mbfklw2c_%25S%20de%20aportaciones%20legal.pdf",
  },
  {
    id: "pb-digitalizacion",
    title: "Plan Nacional de Digitalización y Modernización de la Administración",
    topic: "Innovación Tecnológica",
    date: "2026-08-05",
    summary:
      "Administración moderna, eficiente y centrada en el ciudadano: no repetir información ya aportada y servicios públicos proactivos y accesibles online. La tecnología al servicio de simplificar la vida de las personas.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/ltyzkjc3_PolicyBrief_Digitalizacion_E2-1.pdf",
  },
  {
    id: "pb-vivienda",
    title: "Plan Nacional de Vivienda Asequible",
    topic: "Economía y Turismo",
    date: "2026-08-04",
    summary:
      "Construir vivienda a precio de coste con suelo público, construcción industrializada y financiación institucional. Objetivo: acceso a una vivienda digna y asequible, combatiendo la especulación y la crisis de acceso.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/aph05lvc_PolicyBrief_Vivienda_E2.pdf",
  },
  {
    id: "pb-deuda",
    title: "Plan Nacional de Reducción Sostenible de la Deuda Pública",
    topic: "Economía y Turismo",
    date: "2026-08-03",
    summary:
      "Estrategia integral para reducir progresivamente la deuda pública mediante eficiencia, crecimiento y responsabilidad intergeneracional, fortaleciendo las finanzas públicas sin aumentar la presión fiscal.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/awzyxq9p_PolicyBrief_DeudaNacional_E2-2.pdf",
  },
  {
    id: "pb-plan-50",
    title: "PLAN +50: empleo, experiencia y estabilidad",
    topic: "Empleo y Economía",
    date: "2026-08-02",
    summary:
      "Estrategia nacional contra la discriminación por edad en el empleo de los mayores de 50 años. Incentiva su contratación, reduce el paro de larga duración y aprovecha su experiencia en beneficio de la economía y el bienestar.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/34kpo0qa_Plan%20%2B50.pdf",
  },
  {
    id: "pb-sanidad-247",
    title: "Plan Sanidad 24/7 (turnos 8-8-8)",
    topic: "Sanidad",
    date: "2026-08-06",
    summary:
      "Atención sanitaria continua 24/7 con turnos de 8 horas y personal suficiente para reducir listas de espera y mejorar la calidad. Financiación con ahorros estructurales y contribuciones voluntarias, sin subir impuestos.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/l4mgshf8_Sanidad%2024_7%288_8_8%29%20legal.pdf",
  },
  {
    id: "pb-retorno-experiencia",
    title: "Plan Retorno + Experiencia 2035: talento médico y mentoría senior",
    topic: "Sanidad",
    date: "2026-03-12",
    format: "DOC",
    summary:
      "Recuperar médicos españoles que trabajan en el extranjero y retener la experiencia de los que van a jubilarse con la figura del 'Médico Senior Mentor'. Asegura calidad y cobertura ante la jubilación masiva, con solo el 0,14% del presupuesto sanitario.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/tzi2pl7z_PlanRetornoExperiencia_PolicyBrief-2.docx",
  },
  {
    id: "pb-sueldos-politicos",
    title: "Sueldos y privilegios de políticos: el Estado da ejemplo primero",
    topic: "Transparencia Política",
    date: "2026-03-11",
    format: "DOC",
    summary:
      "Reforma integral de sueldos y privilegios de los cargos públicos para que sean proporcionales a la responsabilidad y transparentes. Reduce salarios, elimina privilegios injustificados y establece un límite de mandatos.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/nocpe74k_SueldosPoliticos_PolicyBrief-2.docx",
  },
  {
    id: "pb-apoyo-maternidad",
    title: "Apoyo real a la maternidad: prevención, protección y libertad con medios",
    topic: "Familia y Sociedad",
    date: "2026-08-10",
    format: "DOC",
    summary:
      "Garantiza que ninguna mujer se vea forzada a decisiones reproductivas por motivos económicos: prevención real, protección laboral efectiva, apoyo económico directo y conciliación que permita ser madre sin sacrificar la carrera.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/kd8nz0l9_ApoyoMaternidad_PolicyBrief-2.docx",
  },
  {
    id: "pb-ebau-fp",
    title: "EBAU única y FP dirigida al empleo: igualdad de origen y formación que funciona",
    topic: "Educación y Cultura",
    date: "2026-08-09",
    format: "DOC",
    summary:
      "Dos reformas contra la desigualdad educativa y el paro juvenil: una EBAU única con estándares comunes en toda España y una Formación Profesional radicalmente orientada al mercado laboral.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/hmg43a47_EBAU_FP_PolicyBrief-2.docx",
  },
  {
    id: "pb-cultura-identidad",
    title: "Cultura e identidad: módulo transversal en el sistema educativo",
    topic: "Educación y Cultura",
    date: "2026-08-08",
    format: "DOC",
    summary:
      "Módulo transversal de cultura e identidad española (cine, música, patrimonio, lenguas cooficiales) en la educación obligatoria, para conectar a los jóvenes con su patrimonio común y reforzar la cohesión territorial.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/7675e06c_CulturaIdentidad_PolicyBrief-2.docx",
  },
  {
    id: "pb-hurto-menor",
    title: "Justicia eficiente frente al hurto leve: consecuencias reales y rápidas",
    topic: "Justicia",
    date: "2026-03-18",
    format: "DOC",
    summary:
      "Tres reformas contra la impunidad del hurto leve: procedimiento inmediato y digitalizado (48-72 h), escala progresiva de sanciones según reincidencia y responsabilidad civil para reparar el daño. Con garantías constitucionales y sin coste neto.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/yvax2knl_HurtoMenor_PolicyBrief-2.docx",
  },
  {
    id: "pb-fundaciones-estatales",
    title: "Fundaciones estatales: eliminar duplicidades y ahorro estructural",
    topic: "Ahorro y Eficiencia",
    date: "2026-03-17",
    format: "DOC",
    summary:
      "Eliminar o fusionar seis fundaciones estatales que duplican funciones ya realizadas por ministerios o entidades públicas, ahorrando millones en costes estructurales y devolviendo esas funciones a su entidad de origen.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/6yt07a5y_FundacionesEstatales_PolicyBrief-2.docx",
  },
  {
    id: "pb-politica-exterior",
    title: "Política exterior: tres ejes estratégicos (UE, Iberoamérica y Mediterráneo)",
    topic: "Política Exterior",
    date: "2026-03-16",
    format: "DOC",
    summary:
      "Reforma de la política exterior centrada en tres ejes interdependientes con intereses concretos, alianzas estratégicas y objetivos medibles, priorizando la diplomacia económica y la defensa activa de los intereses nacionales.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/h6q31r4q_PoliticaExterior_PolicyBrief-2.docx",
  },
  {
    id: "pb-deporte",
    title: "Deporte, industria y salud pública: un modelo integrado",
    topic: "Deporte y Salud",
    date: "2026-03-15",
    format: "DOC",
    summary:
      "Deporte como industria económica, política de salud preventiva (prescripción médica, planes contra el sedentarismo) y marca país. Reorienta la inversión existente sin gasto nuevo, con retorno económico y sanitario medible.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/xdtcd9v9_Deporte_PolicyBrief-2.docx",
  },
  {
    id: "pb-rtve",
    title: "Reforma de RTVE: menos gasto, más control e ingresos propios",
    topic: "Transparencia Política",
    date: "2026-03-14",
    format: "DOC",
    summary:
      "Reforma integral de RTVE (no su eliminación): reducción de gasto por eficiencias estructurales, ingresos propios con publicidad limitada y control de gasto en tiempo real, para un servicio público más eficaz y menos costoso.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/kohbm6c7_RTVE_PolicyBrief-2.docx",
  },
  {
    id: "pb-migratoria",
    title: "Política migratoria: gestión eficiente, legal y ordenada",
    topic: "Migración",
    date: "2026-03-24",
    format: "DOC",
    summary:
      "Modelo de gestión migratoria centrado en eficiencia, legalidad y orden, tratado como asunto técnico y no ideológico. Planificación anual, digitalización administrativa e integración estructural obligatoria, respetando derechos y previniendo tensiones.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/knt1v9lg_PoliticaMigratoria_PolicyBrief-2.docx",
  },
  {
    id: "pb-movilidad-emisiones",
    title: "Movilidad y emisiones: ZBE por emisiones reales, no por antigüedad",
    topic: "Medio Ambiente",
    date: "2026-03-23",
    format: "DOC",
    summary:
      "Zonas de Bajas Emisiones basadas en las emisiones reales del vehículo y no en su antigüedad. Incentiva el 'retrofit' y la responsabilidad del fabricante: con la mitad del coste de subvencionar coches nuevos se reduce más la contaminación del parque actual.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/3abtfi4j_MovilidadEmisiones_PolicyBrief-2.docx",
  },
  {
    id: "pb-bienestar-animal",
    title: "Bienestar y convivencia animal: proteger, reinsertar, convivir",
    topic: "Medio Ambiente",
    date: "2026-03-22",
    format: "DOC",
    summary:
      "Red nacional de acogida y rehabilitación de animales abandonados, usando su cuidado como herramienta de reinserción de reclusos. Reduce abandono, maltrato y reincidencia penal, y mejora la convivencia urbana con enfoque de eficiencia pública.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/qedi43iu_BienestarAnimal_PolicyBrief-3.docx",
  },
  {
    id: "pb-soberania-alimentaria",
    title: "Escudo agrario: soberanía alimentaria, agua y protección al productor",
    topic: "Agricultura y Alimentación",
    date: "2026-03-21",
    format: "DOC",
    summary:
      "Cuatro medidas estructurales: cláusulas espejo para las importaciones, 'autopista del agua' entre cuencas, modernización de regadíos y ley contra la venta a pérdidas. La soberanía alimentaria como cuestión de seguridad nacional.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/m3lbhl2c_SoberaniaAlimentaria_PolicyBrief-2.docx",
  },
  {
    id: "pb-euro-digital",
    title: "Euro digital: innovación sin control estatal del dinero ciudadano",
    topic: "Economía y Turismo",
    date: "2026-03-20",
    format: "DOC",
    summary:
      "Acepta la innovación financiera pero rechaza cualquier euro digital que limite el control del ciudadano sobre su dinero. Cinco garantías irrenunciables: uso voluntario, privacidad garantizada y sin bloqueos ni límites sin proceso legal.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/knf7cwrr_EuroDigital_PolicyBrief-2.docx",
  },
  {
    id: "pb-iva-justo",
    title: "IVA Justo: cuatro tramos proporcionales, cuanto más básico menos pagas",
    topic: "Economía y Turismo",
    date: "2026-03-30",
    format: "DOC",
    summary:
      "Reforma del IVA con cuatro tramos (4%, 8%, 12% y 15%) según la esencialidad del bien o servicio. Los productos más básicos pagan menos, aliviando la carga fiscal de rentas bajas y medias y haciendo el impuesto más proporcional.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/5m2xs9z5_IVAJusto_PolicyBrief-2.docx",
  },
  {
    id: "pb-snai-antiinflacion",
    title: "SNAI: sistema automático anti-inflación (MEPE + IFI)",
    topic: "Economía y Turismo",
    date: "2026-03-29",
    format: "DOC",
    summary:
      "Sistema automático y permanente que amortigua las subidas de precios energéticos y básicos sin intervención política ni deuda pública. Combina el Mecanismo de Estabilidad de Precios Energéticos y un Impuesto Flotante Inteligente, financiado con un fondo de estabilidad.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/tt9azlvu_MEPE_IFI_SNAI_PolicyBrief-2.docx",
  },
  {
    id: "pb-menor-separacion",
    title: "Protección integral del menor en separaciones y divorcios",
    topic: "Justicia",
    date: "2026-03-28",
    format: "DOC",
    summary:
      "Modelo que prioriza la estabilidad del menor: mediación obligatoria, supervisión proporcional al riesgo y apoyo psicológico continuo. Reduce el conflicto parental y acorta procesos con evidencia objetiva (sistema DVO) bajo estricto control judicial.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/356pq4kp_MenorSeparacion_PolicyBrief-2.docx",
  },
  {
    id: "pb-agenda-2030",
    title: "Agenda 2030: del objetivo al plan ejecutable con sentido común",
    topic: "Gobernanza",
    date: "2026-03-27",
    format: "DOC",
    summary:
      "Frente a objetivos sin mecanismos claros, E² detalla cómo alcanzar las metas de desarrollo con financiación real y procesos verificables, adaptados a la realidad española: un modelo de políticas públicas basado en la lógica práctica.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/llbxf76q_Agenda2030_PolicyBrief-2.docx",
  },
  {
    id: "pb-energia",
    title: "Energía producida en España: soberanía, independencia y exportación",
    topic: "Energía",
    date: "2026-04-05",
    format: "DOC",
    summary:
      "Modelo de autosuficiencia energética total: nuclear e hidráulica como base estable, renovables para producción masiva e hidrógeno verde para almacenar excedentes. Reduce la dependencia exterior, abarata la electricidad y genera capacidad de exportación a Europa.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/5by7zkut_Energia_PolicyBrief-2.docx",
  },
  {
    id: "pb-prap",
    title: "PRAP: Plan de Reserva y Ahorro Personal, patrimonio productivo para el ciudadano",
    topic: "Empleo y Economía",
    date: "2026-04-04",
    format: "DOC",
    summary:
      "Los ingresos que superan la base máxima de cotización se convierten en patrimonio privado del trabajador o autónomo. Ese excedente, gestionado de forma segura, genera un activo personal y capital para la inversión productiva nacional.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/vq8kt6wc_PRAP_PolicyBrief-2.docx",
  },
  {
    id: "pb-comercio-digital",
    title: "Comercio digital: Sistema GIF y ticket opcional, papel cero",
    topic: "Economía y Turismo",
    date: "2026-04-03",
    format: "DOC",
    summary:
      "El Sistema GIF automatiza y hace instantáneo el registro fiscal de cada venta en el comercio minorista. Elimina la obligatoriedad del ticket físico (opcional para el cliente), reduce residuos y cargas administrativas y da datos fiscales en tiempo real.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/ixs4nalu_ComercioDigital_PolicyBrief-2.docx",
  },
  {
    id: "pb-rescate-autonomo",
    title: "Plan de Rescate al Autónomo: menos cargas, cotización sobre beneficio real",
    topic: "Empleo y Economía",
    date: "2026-04-02",
    format: "DOC",
    summary:
      "Moderniza el sistema fiscal y de cotizaciones de los autónomos: exención de IVA hasta 85.000 € de facturación anual, cotización sobre el beneficio neto real y una app (GIF) que simplifica la gestión fiscal diaria.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/41ytfqfm_RescateAutonomo_PolicyBrief-2.docx",
  },
  {
    id: "pb-antiocupacion",
    title: "Protocolo Único Antiocupación: clasificación en 24 horas, resolución en días",
    topic: "Justicia",
    date: "2026-04-12",
    format: "DOC",
    summary:
      "Clasifica los casos de ocupación ilegal en 24 horas para agilizar su resolución, distinguiendo entre allanamiento de morada, usurpación e inquiokupación con procedimientos y plazos garantistas para cada uno, sin vulnerar derechos constitucionales.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/n05k367h_Antiocupacion_PolicyBrief-2.docx",
  },
  {
    id: "pb-tarjeta-sanitaria",
    title: "Tarjeta Sanitaria Única Nacional: un historial, toda España",
    topic: "Sanidad",
    date: "2026-04-11",
    format: "DOC",
    summary:
      "Unifica los 17 sistemas sanitarios autonómicos para que el historial médico completo del paciente sea accesible en cualquier centro del país, ganando seguridad y eficiencia y reduciendo duplicidades en pruebas y gasto.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/6kd2b7pl_TarjetaSanitaria_PolicyBrief-2.docx",
  },
  {
    id: "pb-pensionistas",
    title: "Pensiones: justicia por esfuerzo y protección de las nuevas generaciones",
    topic: "Empleo y Economía",
    date: "2026-04-10",
    format: "DOC",
    summary:
      "Modelo de dos caminos: una pensión bruta garantizada según los años cotizados (base mínima digna) y una aportación progresiva de los pensionistas según su pensión, que refuerza la sostenibilidad del sistema para las nuevas generaciones.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/zt4utry4_Pensionistas_PolicyBrief-2.docx",
  },
  {
    id: "pb-ciberseguridad",
    title: "Ciberseguridad nacional: infraestructuras, ciudadanos y soberanía digital",
    topic: "Emergencias y Seguridad",
    date: "2026-04-09",
    format: "DOC",
    summary:
      "Modelo nacional de ciberseguridad en cuatro pilares: protección de infraestructuras críticas, defensa del ciudadano digital, soberanía tecnológica y talento nacional. Integra la seguridad desde el diseño en todos los sistemas digitales del Estado.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/4d4mzm6r_Ciberseguridad_PolicyBrief-1.docx",
  },
  {
    id: "pb-limitacion-amnistias",
    title: "Limitación y regulación reforzada de las amnistías y medidas de gracia",
    topic: "Gobernanza",
    date: "2026-04-20",
    summary:
      "Somete las amnistías y medidas extraordinarias a altos estándares de transparencia, control democrático y seguridad jurídica, evitando que estas herramientas excepcionales se conviertan en un uso político ordinario.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/kmhrh30h_PolicyBrief_LimitacionAmnistias_E2.pdf",
  },
  {
    id: "pb-fin-aforamientos",
    title: "Fin de los aforamientos: igualdad ante la ley",
    topic: "Transparencia Política",
    date: "2026-04-19",
    summary:
      "Elimina los aforamientos políticos ordinarios para que los cargos públicos sean juzgados por los mismos tribunales que cualquier ciudadano, reforzando la confianza institucional y la cultura de responsabilidad pública.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/6gtxh1sr_PolicyBrief_FinAforamientos_E2.pdf",
  },
  {
    id: "pb-fin-pagas-vitalicias",
    title: "Fin de las pagas vitalicias y privilegios económicos de cargos públicos",
    topic: "Transparencia Política",
    date: "2026-04-18",
    summary:
      "Equipara los derechos de protección social de los cargos públicos a los de cualquier ciudadano: las prestaciones se basarán en cotizaciones efectivas y circunstancias objetivas, ganando igualdad, transparencia y legitimidad democrática.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/b7ai3k2j_PolicyBrief_FinPagasVitalicias_E2.pdf",
  },
  {
    id: "pb-9-ministerios",
    title: "Estructura de 9 ministerios: una Administración más eficiente",
    topic: "Ahorro y Eficiencia",
    date: "2026-04-17",
    summary:
      "Reorganiza el Gobierno reduciendo los ministerios de 22-23 a 9 para optimizar la coordinación, aumentar la transparencia y reducir duplicidades, con metas cuantificables de ahorro y de tiempos de tramitación.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/tg2pu36z_PolicyBrief_Estructura9Ministerios_E2.pdf",
  },
  {
    id: "pb-justicia-independiente",
    title: "Plan Nacional de Justicia Independiente, Transparente y al Servicio del Ciudadano",
    topic: "Justicia",
    date: "2026-04-21",
    format: "DOC",
    summary:
      "Refuerza la independencia del Poder Judicial y la objetividad del Ministerio Fiscal: elección a tres bandas (carrera, mérito y ratificación), transparencia de nombramientos, trazabilidad digital, reparto objetivo de asuntos y agilización procesal. La Justicia pertenece a los ciudadanos y a la ley.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/d0tzfrng_PolicyBrief_Justicia_E2-1.docx",
  },
  {
    id: "pb-salud-mental",
    title: "Plan Nacional de Salud Mental: prevención, atención y destigmatización",
    topic: "Sanidad",
    date: "2026-04-28",
    format: "DOC",
    summary:
      "Más psicólogos y menos listas de espera, educación emocional en las escuelas y protocolos de prevención del suicidio y protección de colectivos vulnerables, convirtiendo la salud mental en una prioridad sanitaria.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/bz68got1_PolicyBrief_SaludMental_E2.docx",
  },
  {
    id: "pb-reforma-electoral",
    title: "Reforma del sistema electoral: proporcionalidad, representación y participación",
    topic: "Gobernanza",
    date: "2026-04-27",
    format: "DOC",
    summary:
      "Corrige la desproporción del valor del voto entre provincias y la barrera del 3%, introduce listas desbloqueadas o mixtas, refuerza la transparencia en la financiación de partidos y fomenta la participación (voto electrónico y democracia directa).",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/rq49l8v7_PolicyBrief_ReformaElectoral_E2.docx",
  },
  {
    id: "pb-financiacion-autonomica",
    title: "Reforma de la financiación autonómica: equidad, transparencia y solidaridad",
    topic: "Gobernanza",
    date: "2026-04-26",
    format: "DOC",
    summary:
      "Reforma el caducado sistema de financiación autonómica para garantizar servicios públicos equitativos vivas donde vivas, con criterios transparentes, objetivos y auditables, y solidaridad territorial sostenible.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/64mh2a5u_PolicyBrief_FinanciacionAutonomica_E2.docx",
  },
  {
    id: "pb-espana-vaciada",
    title: "España vaciada: plan nacional contra la despoblación y por el equilibrio territorial",
    topic: "Territorio y Despoblación",
    date: "2026-04-25",
    format: "DOC",
    summary:
      "Revierte la pérdida de población rural con conectividad, servicios públicos de proximidad, incentivos fiscales y apoyo al sector agrario y al tejido empresarial del interior.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/g98vfnua_PolicyBrief_Espa%C3%B1aVaciada_E2.docx",
  },
  {
    id: "pb-dependencia",
    title: "Atención a la Dependencia y derechos de las personas con discapacidad",
    topic: "Familia y Sociedad",
    date: "2026-04-24",
    format: "DOC",
    summary:
      "Garantiza resoluciones en un máximo de 6 meses, protege a los cuidadores y asegura la accesibilidad universal, la empleabilidad y la integración sociosanitaria para mejorar la calidad de vida y reducir desigualdades.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/55m7h0v9_PolicyBrief_Dependencia_E2.docx",
  },
  {
    id: "pb-violencia-genero",
    title: "Plan Nacional contra la Violencia de Género",
    topic: "Igualdad y Derechos",
    date: "2026-08-13",
    summary:
      "Respuesta integral a la violencia de género: prevención educativa desde la infancia, protección efectiva de las víctimas, sanción y reparación integral. Refuerza recursos, formación y la aplicación real de las leyes existentes.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/qmg1obm1_PolicyBrief_ViolenciaGenero_E2.pdf",
  },
  {
    id: "pb-transporte",
    title: "Plan Nacional de Transporte e Infraestructuras: mantener antes que construir",
    topic: "Transporte e Infraestructuras",
    date: "2026-08-12",
    summary:
      "Prioriza el mantenimiento, la sostenibilidad y la intermodalidad sobre la obra nueva, evaluando con rigor el retorno real de cada inversión. Optimiza la red existente para mejorar la conectividad y la cohesión territorial.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/u01p9lyr_PolicyBrief_Transporte_E2.pdf",
  },
  {
    id: "pb-ciencia",
    title: "Plan Nacional de Ciencia, Investigación y Conocimiento",
    topic: "Ciencia e I+D",
    date: "2026-08-11",
    summary:
      "Convierte la ciencia en política de Estado: financiación estable y predecible (con garantía legal), carrera investigadora digna, retención y atracción de talento, y soberanía científica en áreas estratégicas como IA, biotecnología y energía.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/en4931x4_PolicyBrief_Ciencia_E2.pdf",
  },
  {
    id: "pb-innovacion",
    title: "Plan Nacional de Innovación, I+D+I y Emprendimiento Tecnológico",
    topic: "Innovación Tecnológica",
    date: "2026-08-10",
    summary:
      "Hace de la innovación y el emprendimiento tecnológico una prioridad estratégica: más inversión en I+D+I, un ecosistema emprendedor más fuerte, retención de talento y máxima captación de fondos europeos para competir en el siglo XXI.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/31q42ast_PolicyBrief_Innovacion_E2-1.pdf",
  },
  {
    id: "pb-ultima-oportunidad",
    title: "Sistema E² «Última Oportunidad»: menos desperdicio de alimentos",
    topic: "Medio Ambiente",
    date: "2026-08-09",
    summary:
      "Plataforma digital que permite a los comercios vender productos cercanos a su fecha de caducidad a precio reducido. Evita el desperdicio de alimentos, genera ahorro para el consumidor y beneficio para los establecimientos.",
    pdf:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_espana-e2/artifacts/z0op0g1p_PolicyBrief_UltimaOportunidad_E2-1.pdf",
  },
];

export const NOTICIAS = [
  {
    date: "2026-07-01",
    tag: "Policy Brief",
    title: "Jornada laboral: 40 horas bien distribuidas y viernes tarde libre",
    text: "Publicamos dos propuestas para redistribuir la jornada sin reducir producción ni salario: 40 horas mejor repartidas y una jornada continua adaptada a trabajos físicos.",
  },
  {
    date: "2026-06-15",
    tag: "Policy Brief",
    title: "Protección de empresas y autónomos frente al fraude en la incapacidad temporal",
    text: "Un sistema equilibrado que protege al trabajador enfermo y a la vez la viabilidad de empresas y autónomos, con mecanismos de comprobación objetivos y proporcionales.",
  },
  {
    date: "2026-06-01",
    tag: "Transparencia",
    title: "Sindicatos y patronal: quien recibe dinero público rinde cuentas",
    text: "Nuevo brief que exige a sindicatos y patronal las mismas obligaciones de transparencia que cualquier entidad que gestione fondos públicos.",
  },
  {
    date: "2026-05-06",
    tag: "Análisis",
    title: "Comparativa de reducción de jornada: Gobierno vs Europa vs E²",
    text: "Análisis del modelo basado en el consenso y la flexibilidad sectorial, frente a los decretos unilaterales, con referencias a los países europeos con mejores condiciones.",
  },
];
